module.exports = __webpack_public_path__ + "static/media/interviews.cdcc00dd.svg";